import { render, staticRenderFns } from "./PerguntaShow.vue?vue&type=template&id=c09dfa36&scoped=true&"
import script from "./PerguntaShow.vue?vue&type=script&lang=js&"
export * from "./PerguntaShow.vue?vue&type=script&lang=js&"
import style0 from "./PerguntaShow.vue?vue&type=style&index=0&id=c09dfa36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09dfa36",
  null
  
)

export default component.exports